import { render, staticRenderFns } from "./buttonPhone.pug?vue&type=template&id=4cc27202&lang=pug&external"
import script from "./buttonPhone.js?vue&type=script&lang=js&external"
export * from "./buttonPhone.js?vue&type=script&lang=js&external"
import style0 from "./buttonPhone.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc27202')) {
      api.createRecord('4cc27202', component.options)
    } else {
      api.reload('4cc27202', component.options)
    }
    module.hot.accept("./buttonPhone.pug?vue&type=template&id=4cc27202&lang=pug&external", function () {
      api.rerender('4cc27202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttonPhone/index.vue"
export default component.exports